import React from 'react';
import SubjectPage from '../structure/SubjectPage';

const CM_AI = ({ branch = "AIML", semester = "4th Semester" }) => {
  const accordionContent = [
    <div key="1" className="p-4">
      <p>Numerical solution to Linear algebraic & transcendental equations- Numerical algorithms
        and their complexities, Computer implementation and efficiency, Root finding- bracketing
        methods: Bracketing Methods, graphical methods, Bisection method, False Position (Regula
        Falsi), Root finding -Open Methods: Simple Fixed-Point Iteration, Newton-Raphson method,
        Secant methods, Brent's method.</p>
    </div>,
    <div key="2" className="p-4">
      <p>Numerical linear algebra- Gauss elimination, Pivoting, Tridiagonal systems, LU factorization,
        Gauss elimination as LU factorization, Cholesky factorization, Matrix inverse and condition, Error
        analysis and system condition. Iterative Methods: Gauss-Seidel method, Nonlinear Systems.
        Eigenvalues: The Power Method, Interpolations: Newton and Gauss formulas, Stirling and Bessel
        Formula, Lagrange's, piecewise/splines.</p>
    </div>,
    <div key="3" className="p-4">
      <p>Numerical Differentiation- High-Accuracy differentiation formulas, Richardson Extrapolation,
        Derivatives of unequally spaced data, Partial Derivatives. Numerical Integration: Newton-Cotes
        Formulas, The trapezoidal rule, Simpson's Rules, Higher-Order Newton-Cotes formula, Romberg
        integration, Gauss quadrature, Adaptive quadrature</p>
    </div>,
    <div key="4" className="p-4">
      <p>Ordinary differential equations- Euler's Method, Runge-Kutta Methods, Adaptive methods,
        finite difference methods, Initial value problems, Boundary value problems, Partial differential
        equations.</p>
    </div>
  ];

  const tabData = [
    { id: 'syllabus', label: 'Syllabus', content: null },
    { id: 'notes', label: 'Notes', content: null },
    { id: 'important', label: 'Important Questions', content: null },
    { id: 'books', label: 'Books', content: null },
    { id: 'PYQ', label: 'PYQ', content: null },
    { id: 'youtube_playlist', label: 'Video Lectures', content: null },
  ];

  return (
    <SubjectPage
      subjectName="Computational Methods"
      subjectKey="AI_CM"
      branch={branch}
      semester={semester}
      accordionContent={accordionContent}
      tabData={tabData}
      adminEmail="snaped4338@gmail.com"
      firestoreCollections={{
        notes: 'CM_AINotes',
        videos: 'CM_AIVideos'
      }}
    />
  );
};

export default CM_AI;